import { FaqCategoryListParams } from 'Modules'

/** Drop empty filters so `{ search: '' }` and `{}` share one cache entry */
const normalizeListParams = (params: FaqCategoryListParams): FaqCategoryListParams => {
  const normalized: FaqCategoryListParams = {}
  const search = params.search?.trim()
  if (search) normalized.search = search
  if (params.articleStatus) normalized.articleStatus = params.articleStatus
  if (params.categoryVisibility) normalized.categoryVisibility = params.categoryVisibility
  return normalized
}

export const faqCategoryKeys = {
  all: ['faqCategory'] as const,
  lists: () => [...faqCategoryKeys.all, 'list'] as const,
  list: (params: FaqCategoryListParams = {}) =>
    [...faqCategoryKeys.lists(), normalizeListParams(params)] as const,
}

export const faqArticleKeys = {
  all: ['faqArticle'] as const,
  detail: (id: string) => [...faqArticleKeys.all, 'detail', id] as const,
}
